import { format, isDate } from 'date-fns';
import type { EChartsOption } from 'echarts';

const schaeffler_green = '#00893d';

export const multilane_config: () => EChartsOption = () => ({
  animationDuration: 0,
  animation: false,
  toolbox: {
    show: false,
    orient: 'vertical',
    top: 0,
    right: 15,
    emphasis: {
      iconStyle: {
        borderColor: schaeffler_green,
      },
    },
    feature: {},
  },
  brush: {
    toolbox: ['lineX', 'clear'],
    xAxisIndex: 'all',
    throttleType: 'debounce',
  },
  tooltip: {
    trigger: 'axis',
    appendToBody: true,
    axisPointer: {
      type: 'cross',
      animation: false,
      label: {
        backgroundColor: '#ccc',
        borderColor: '#aaa',
        borderWidth: 1,
        shadowBlur: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        color: '#222',
        formatter: (paramLabel) => {
          // Handle x-axis timestamps (date objects, numbers or strings)
          if (paramLabel.axisDimension === 'x') {
            if (isDate(paramLabel.value)) {
              return `${format(paramLabel.value, 'eee, MMM d, y, hh:mm:ss aa')}`;
            } else if (typeof paramLabel.value === 'number' && !Number.isNaN(paramLabel.value)) {
              return `${format(new Date(paramLabel.value), 'eee, MMM d, y, hh:mm:ss aa')}`;
            } else if (typeof paramLabel.value === 'string' && !Number.isNaN(Date.parse(paramLabel.value))) {
              return `${format(new Date(paramLabel.value), 'eee, MMM d, y, hh:mm:ss aa')}`;
            }
          }

          // For non-date values, show as a number with 2 decimal places
          return Number(paramLabel.value).toFixed(2);
        },
      },
    },
  },
  axisPointer: {
    link: [
      {
        xAxisIndex: 'all',
      },
    ],
  },
  dataZoom: [],
  series: [],
  xAxis: [],
  yAxis: [],
  grid: [],
});
